import { useCallback, useState } from "react";

const initialState = {
  isOpen: false,
  masterId: null,
};
export const useFreeSlotsModalState = () => {
  const [state, setState] = useState(initialState);
  const open = useCallback((masterId) => {
    setState({
      isOpen: true,
      masterId,
    });
  }, []);
  const close = useCallback(() => {
    setState(initialState);
  }, []);
  return { state, open, close };
};
